import { defaultProps } from './index'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const TextSettings = () => {
  return <LayoutToolbarSection defaultProps={defaultProps} initOpen />
}
